import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-text-slice',
  templateUrl: './ui-text-slice.component.html',
  styleUrls: ['./ui-text-slice.component.scss']
})
export class UiTextSliceComponent implements OnChanges {
  @Input() public text: string = '';
  @Input() public size: number = 160;
  @Input() public isPink: boolean = false;
  @Input() public isAddMoreBlue: boolean = false;
  @Input() public isPrimary: boolean = false;
  @Input() public moreLabel: string;
  @Input() public hideLabel: string;

  public expand: boolean = false;
  public isOverflow: boolean = false;

  ngOnChanges() {
    this.isOverflow = this.text.length > this.size;
  }
}
